<template>
  <v-btn
    class="radio-button"
    block
    large
    elevation="0"
    :text="!innerValue"
    @click="$emit('click')"
  >
    <font-awesome-icon
      v-if="innerValue"
      icon="check-circle"
      class="secondary--text"
    ></font-awesome-icon>
    <font-awesome-icon
      v-else
      :class="`${inError ? 'red--text darken-2' : 'grey--text darken--4'}`"
      :icon="['far', 'circle']"
    ></font-awesome-icon>
    <span
      class="ml-3"
      :class="{
        'font-weight-bold': innerValue
      }"
    >
      {{ text }}</span
    >
  </v-btn>
</template>

<script>
export default {
  data: () => ({
    innerValue: false
  }),
  props: {
    text: String,
    value: Boolean,
    inError: Boolean
  },
  watch: {
    value(val, prev) {
      if (val != prev) this.innerValue = JSON.parse(JSON.stringify(val));
    },
    innerValue(value, prev) {
      if (value != prev) this.$emit("input", value);
    }
  },
  mounted() {
    if (this.value) this.innerValue = JSON.parse(JSON.stringify(this.value));
  }
};
</script>
